import type { EmbeddedDashboard } from '@preset-sdk/embedded';
import type { GuestToken } from '@owl-frontend/api-client/interface';
import { AsyncActionState, setupSlice } from '@owl-frontend/redux';

export interface InsightsState {
  overview: { [key: string]: any };
  findings: { [key: string]: any };
  team: { [key: string]: any[] };
  guestToken?: string;
  dashboard?: EmbeddedDashboard;
  actions: {
    fetchOverview: AsyncActionState;
    fetchFindings: AsyncActionState;
    fetchTeam: AsyncActionState;
    renderAdvancedInsightsDashboard: AsyncActionState<{
      guestToken: GuestToken;
    }>;
    renderLtdBucketsDashboard: AsyncActionState<{
      guestToken: GuestToken;
    }>;
  };
}

const initialState: InsightsState = {
  overview: {},
  findings: {},
  team: {},
  actions: {
    fetchOverview: { status: 'uninitialized' },
    fetchFindings: { status: 'uninitialized' },
    fetchTeam: { status: 'uninitialized' },
    renderAdvancedInsightsDashboard: { status: 'uninitialized' },
    renderLtdBucketsDashboard: { status: 'uninitialized' },
  },
};

const insightsDetailsSlice = setupSlice('insights', initialState);
export default insightsDetailsSlice;
